import { c as e, d as i, a as l } from "../_rollupPluginBabelHelpers-d2f9cf82.js";
var r = "/storelocator/richfields/",
  n = ["original", "small", "xsmall", "thumbnail"],
  a = new (function () {
    function a() {
      i(this, a);
    }
    return e(a, [{
      key: "richFieldImage",
      value: function (e) {
        var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "small";
        if (!e) return e;
        var l = e.indexOf(r);
        if (-1 === l) return e;
        var a = l + r.length,
          t = e.slice(a),
          s = t.indexOf("/");
        if (-1 === s) return e;
        var u = t.slice(0, s);
        if (!n.includes(u)) return e;
        var c = n.includes(i) ? i : "small";
        return u === c ? e : e.slice(0, a) + c + t.slice(s);
      }
    }, {
      key: "srcSetRichFields",
      value: function () {
        var e = this,
          i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "small",
          r = arguments.length > 1 ? arguments[1] : void 0;
        return r ? l(l({}, r), {}, {
          fields: (r.fields || []).map(function (r) {
            return l(l({}, r), {}, {
              image: e.richFieldImage(r.image, i)
            });
          })
        }) : r;
      }
    }]), a;
  }())();
export { a as default };